import { render, staticRenderFns } from "./TrueFalseSelectbox.vue?vue&type=template&id=370c3740"
import script from "./TrueFalseSelectbox.vue?vue&type=script&lang=js"
export * from "./TrueFalseSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports